/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Edit reference sketches</h4>

<p>While in this mode, the reference sketches become editable, and you can use the relevant tools to change their size and position.</p>`;

export default function EditSketchesTooltip() {
    return h('div', { innerHTML: body });
}
